import Boto from 'components/ui/Boto';
import styles from './notfound.module.scss';

export default function NotFound(props) {
    const { code, text, cleanUrlParams } = props;

    return (
        <div className={styles.notfound} data-testid={`error-${code}`}>
            <h3 className={styles.code}>{code}</h3>
            <p className={styles.text}>{text}</p>
            <Boto
                tag='a'
                text='VES A 3CAT'
                className={styles.boto}
                fons='fosc'
                route={{ href: '/3cat' }}
                cleanUrlParams={cleanUrlParams}
            />
        </div>
    );
}

NotFound.defaultProps = {
    text: '',
    cleanUrlParams: false
};
